$('#downloadTl').popover({
    container: 'body',
    trigger: 'focus'
});

// Preloader при заугрзке Ajax
$(document).ajaxStart(function () {
    $("body").css("overflow", "hidden");
    $('.loader-block').addClass("loader");
});
$(document).ajaxStop(function () {
    $("body").css("overflow", "unset");
    $('.loader-block').removeClass("loader");
});

// Заголовок с загрузкой
var lenProgress = $('.progress-load').length;
var elements = 100 / lenProgress;
$('.progress-load').each(function (i, elem) {
    $(this).closest('.loading').find(".number").text('0' + (i + 1));
    $(this).css({width: (elements * (i + 1)) + '%'});
});

$('.tree-drop').click(function () {
    if ($(this).hasClass('show')) {
        $(this).removeClass('show');
    } else {
        $(this).addClass('show');
    }
});

$('.phone-mask').mask("+7 (999) 999-99-99");
$('.mail-index-mask').mask("999999");

// Глаз для пароля в форме Мишины наработочки
// var input = $('#password');
// var inputReturn = $('#password-return');
// var eye = $('.eye');
// var eyeReturn = $('.eye-return');
//
// $('.svg-eye.set').click(function () {
//     if (input.attr('type') === 'password') {
//         input.prop('type', 'text')
//         eye.hide()
//     } else {
//         input.prop('type', 'password')
//         eye.show()
//     }
// });
//
// $('.svg-eye.return').click(function () {
//     if (inputReturn.attr('type') === 'password') {
//         inputReturn.prop('type', 'text');
//         eyeReturn.hide();
//     } else {
//         inputReturn.prop('type', 'password')
//         eyeReturn.show()
//     }
// });

(function ($) {
    $(function () {
        // Фиксация кнопок
        var elementFixed = $('.fixed-buttons');
        var elementStatic = $('.static-buttons');
        var hideEl = {'opacity': '0', 'display': 'none'};
        var showEl = {'opacity': '1', 'display': 'block'};

        if ($(window).width() < 992) {
            elementStatic.css(hideEl);
            elementFixed.css(showEl);
        } else {
            $(window).scroll(function () {
                elementStatic.css(elementFixed.css('opacity') !== '1' ? showEl : hideEl);
                if ($(window).width() > 991) {
                    elementFixed.css($(this).scrollTop() > 300 ? showEl : hideEl);
                }
            });
        }


        // Выпадающий список (jquery formstyler)
        if ($(window).width() > 991) {
            $('.input-select').styler({
                selectSmartPositioning: false
            });
        }
    });
})(jQuery);

$(document).ready(function () {
    $('form .link').popover();
    if (document.querySelector('.input-select')) {
        var ulArray = document.querySelectorAll('div.jq-selectbox div.jq-selectbox__dropdown ul');
        for(var i = 0; i < ulArray.length; i++){
            ulArray[i].addEventListener('click', function (e) {
                var event;
                if(typeof(Event) === 'function') {
                    event = new Event('change');
                }else{
                    event = document.createEvent('Event');
                    event.initEvent('change', true, true);
                }
                try {
                    this.parentNode.parentNode.querySelector('.input-select').dispatchEvent(event);
                } catch (e) {}
            });
        }
    }
});

if (!navigator.cookieEnabled) {
    document.querySelector('#has-cookie').style.display = 'block';
} else {
    if (!App.cookie.get('testingCookie')) {
        App.cookie.set("testingCookie", "works", {path:'/'});
    }
    if (App.cookie.get('testingCookie') === 'works') {
        document.querySelector('#accept-cookie').style.display = 'block';
        //document.querySelector('#accept-lineBanner').style.display = 'none';
        document.querySelector('#accept-cookie .close').onclick = function () {
            App.cookie.set("testingCookie", "accept", {path:'/'});
        };
    } else if (App.cookie.get('testingCookie') === 'accept') {
        document.querySelector('#accept-cookie').style.display = 'none';
        //document.querySelector('#accept-lineBanner').style.display = 'flex';
    }
}

// if (document.getElementsByName('course')[0]) {
//     document.getElementsByName('course')[0].onchange = function () {
//         angular.element(document.getElementsByName('tlForm')[0]).scope().fields.course = this.selectedOptions[0].value;
//     };
// }
// if (document.getElementsByName('region')[0]) {
//     document.getElementsByName('region')[0].onchange = function () {
//         angular.element(document.getElementsByName('tlForm')[0]).scope().fields.region = this.selectedOptions[0].value;
//     }
// }

// ставим куки tl_source, в которых записываем uri лэндига, с которого запрошены пробные уроки
$('.tl-source').click(function () {
    var expiresDays = 7 *24*60*60;
    var uri = document.location.pathname;
    App.cookie.set('tl_source', uri, {path:'/', expires: expiresDays});
});
